/* eslint-disable */
var redirectURL = ""
var mapBoxToken = ""

var mapUrl = {
  generateToken : "https://au1gis.solutions.arcadis.com/arcgis/sharing/rest/generateToken",
  dataLayerBase : "https://au1gis.solutions.arcadis.com/arcgis/rest/services/CherryFirm/Collector_SampleV2/FeatureServer/0/",
  constraintLayerBase : "https://au1gis.solutions.arcadis.com/arcgis/rest/services/CherryFirm/Collector_Base/MapServer/",
  constraintTurbines: "https://au1gis.solutions.arcadis.com/arcgis/rest/services/Hosted/Wind_Turbine_Labels/",
  constraintHardstands: "https://au1gis.solutions.arcadis.com/arcgis/rest/services/Hosted/Hardstands/"
}

var documentReportConfig = {
  docTitle: "Cherry Collector", // Name of the Report
  docTableHeader: ["Object ID", "Location", "Note", "Image", "Map Location"] // Name of table columns that will appear on the Document
}

if (process.env.NODE_ENV === 'production') {
  // This will be replaced with the server endpoint for demo purposes
  redirectURL = 'http://cherryreportgenerator.geodemosolutions.com'
  mapBoxToken = "pk.eyJ1Ijoic2hlZW5hdmVyZGFkIiwiYSI6ImNqczluMmgwczB3eDE0M3A4b214eXdpNnAifQ.lLWyueusm4W2jxVaB1j9rA"
  // baseApiUrl = 'http://sustainabilitybackend.geodemosolutions.com/public/'
  // baseApiUrl = 'http://sustainabilitybackend.geodemosolutions.com/'
 }
else {
  redirectURL = 'http://localhost:19001/'
  // baseApiUrl = 'http://localhost:8000/'
  mapBoxToken = "pk.eyJ1IjoicXVpbmVzbGEiLCJhIjoiY2pzOW16NmthMHo4bTQ0bGlic3VjZGtsdyJ9.ggMkRs_gY9KGy3IiPcmkxw"
}

export {
  redirectURL,
  mapBoxToken,
  mapUrl,
  documentReportConfig
}
